import styled from 'styled-components';
import PropTypes from 'prop-types';
import colors from 'pubweb-react-components/dist/styles/colors';
import LandingPageStyles from '../../../styles/LandingPageStyles';

const marketingFormInputWidth = "100%";

const FormInput = styled.input`
  background-color: #ffffff;
  background-image: none;
  border: 1px solid ${colors.miscMediumGrey};
  box-shadow: none;
  font-size: 1rem;
  height: 42px;
  line-height: 1.6;
  margin: 0;
  outline: none;
  padding: 0.5rem;
  transition: all 400ms ease-in;
  width: ${props => props.width ? props.width : marketingFormInputWidth};

  /* - DESKTOP VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.desktop}){

    }

     /* - TABLET VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.tablet}){
        margin-top: 0px;
    }

    /* - MOBILE VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.mobile}){

    }
`;

FormInput.propTypes = {
  width: PropTypes.string
}

export default FormInput;



// WEBPACK FOOTER //
// ./src/components/Form/styles/FormInput.js